import {isDateTbd} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {EventText} from '../../../../../../commons/components/event-text'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import {MobileDateProps} from './interfaces'
import s from './mobile-date.scss'

export const MobileDate = ({event}: MobileDateProps) => {
  const {t} = useTranslation()
  const {day, month} = useEventDateInformation(event.event.id)

  return (
    <div className={s.mobileDateContainer}>
      {isDateTbd(event.event) ? (
        <div className={s.tbdDate}>
          <EventText>{t('events.tbd-time')}</EventText>
        </div>
      ) : (
        <div className={s.mobileDate}>
          <EventText>{day}</EventText>
          <EventText faded>{month}</EventText>
        </div>
      )}
    </div>
  )
}
